import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export const useProfileManagement = () => {
  const createOrUpdateProfile = async (
    userId: string,
    loginType: "owner" | "admin"
  ) => {
    try {
      // First, try to get the existing profile
      const { data: existingProfile, error: fetchError } = await supabase
        .from("profiles")
        .select("id, user_type, login_type")
        .eq("id", userId)
        .single();

      if (fetchError && fetchError.code !== "PGRST116") {
        console.error("Error fetching profile:", fetchError);
        toast.error("Erreur lors de la récupération du profil");
        return null;
      }

      // If profile doesn't exist, create it
      if (!existingProfile) {
        const { data: newProfile, error: insertError } = await supabase
          .from("profiles")
          .insert([
            {
              id: userId,
              user_type: loginType === "admin" ? "admin" : "owner",
              login_type: loginType,
            },
          ])
          .select()
          .single();

        if (insertError) {
          console.error("Error creating profile:", insertError);
          toast.error("Erreur lors de la création du profil");
          return null;
        }

        return newProfile;
      }

      return existingProfile;
    } catch (error) {
      console.error("Error in profile management:", error);
      toast.error("Erreur lors de la gestion du profil");
      return null;
    }
  };

  return { createOrUpdateProfile };
};